/* Semveta cart drawer — native replacement for UpCart.
   Talks to Shopify's AJAX cart API directly; no theme JS dependency. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('SemvetaCartConfig');
  var root = document.getElementById('SemvetaCart');
  if (!cfgEl || !root) return;

  var CFG = JSON.parse(cfgEl.textContent);
  var state = { cart: null, busy: false, open: false, lastFocus: null };

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var el = {
    drawer: $('.svc__drawer'),
    items: $('[data-svc-items]'),
    empty: $('[data-svc-empty]'),
    recs: $('[data-svc-recs]'),
    ship: $('[data-svc-ship]'),
    shipNote: $('[data-svc-ship-note]'),
    meter: $('[data-svc-meter]'),
    discount: $('[data-svc-discount]'),
    discountAmt: $('[data-svc-discount-amt]'),
    total: $('[data-svc-total]'),
    checkout: $('[data-svc-checkout]'),
    loading: $('[data-svc-loading]')
  };

  /* ---------- helpers ---------- */

  function money(cents) {
    var cur = (state.cart && state.cart.currency) || CFG.currency || 'GBP';
    try {
      return new Intl.NumberFormat(CFG.locale || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + w + 'x' + w + '_crop_center$1$2');
  }

  function api(url, body) {
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
        return j;
      });
    });
  }

  function setBusy(b) {
    state.busy = b;
    el.loading.hidden = !b;
  }

  /* ---------- plan option helpers ---------- */

  function planApplies(item) {
    if (!CFG.plans) return false;
    if (CFG.plans.handle && item.handle === CFG.plans.handle) return true;
    if (CFG.plans.sampleHandle && item.handle === CFG.plans.sampleHandle) return true;
    if (Number(item.product_id) === Number(CFG.plans.productId)) return true;
    // Duplicate Chaski products exist in admin; match on exact title so packs are excluded.
    if (CFG.plans.productTitle && String(item.product_title).trim() === CFG.plans.productTitle) return true;
    return !!planOptionFor(item);
  }

  function planOptionFor(item) {
    if (!CFG.plans) return null;
    var vid = Number(item.variant_id);
    var sp = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    var planId = sp ? Number(sp.id) : null;
    var planName = sp ? String(sp.name).trim() : null;
    var vt = String(item.variant_title || '').trim();
    var i, o;
    // 1) exact ID match
    for (i = 0; i < CFG.plans.options.length; i++) {
      o = CFG.plans.options[i];
      if (Number(o.variantId) === vid && (o.sellingPlanId ? Number(o.sellingPlanId) : null) === planId) return o;
    }
    // 2) fallback: variant title + plan name (covers duplicate products with the same structure)
    for (i = 0; i < CFG.plans.options.length; i++) {
      o = CFG.plans.options[i];
      if (o.match && o.match.variantTitle === vt && (o.match.planName || null) === planName) return o;
    }
    return null;
  }

  function planSelectHtml(current) {
    var groups = {};
    var order = [];
    CFG.plans.options.forEach(function (o) {
      if (!groups[o.group]) { groups[o.group] = []; order.push(o.group); }
      groups[o.group].push(o);
    });
    var html = '<div class="svc__field"><select aria-label="' + esc(CFG.plans.label) + '" data-svc-plan>';
    if (!current) html += '<option value="" selected disabled>' + esc(CFG.plans.label) + '</option>';
    order.forEach(function (g) {
      html += '<optgroup label="' + esc(g) + '">';
      groups[g].forEach(function (o) {
        html += '<option value="' + esc(o.id) + '"' + (current && current.id === o.id ? ' selected' : '') + '>' + esc(o.label) + '</option>';
      });
      html += '</optgroup>';
    });
    html += '</select><svg viewBox="0 0 28 16" width="14" height="9" fill="none" stroke="#6b6055" stroke-width="2"><path d="M1.5 2 L14 13 L26.5 2"></path></svg></div>';
    return html;
  }

  /* ---------- render ---------- */

  function itemHtml(item) {
    var plan = planOptionFor(item);
    var showPlan = planApplies(item);
    // One-time purchase: show the upgrade button instead of the dropdown
    var showUpgrade = showPlan && CFG.plans.upgrade && plan && plan.id === CFG.plans.upgrade.fromOption;
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var planName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
    var planOverridden = false;
    if (planName && CFG.plans && CFG.plans.planNameOverrides && CFG.plans.planNameOverrides[planName]) {
      planName = CFG.plans.planNameOverrides[planName];
      planOverridden = true;
    }
    var priceHtml = item.original_line_price !== item.final_line_price
      ? '<s>' + money(item.original_line_price) + '</s>' + money(item.final_line_price)
      : money(item.final_line_price);

    return '' +
      '<div class="svc__item" data-svc-item data-key="' + esc(item.key) + '">' +
        '<div class="svc__item-row">' +
          '<a class="svc__thumb" href="' + esc(item.url) + '">' +
            (item.image ? '<img src="' + esc(imgUrl(item.image, 184)) + '" width="92" height="92" alt="' + esc(item.product_title) + '">' : '') +
          '</a>' +
          '<div class="svc__item-main">' +
            '<div class="svc__item-title-row">' +
              '<a class="svc__item-name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              '<button class="svc__remove" type="button" title="Remove" aria-label="Remove ' + esc(item.product_title) + '" data-svc-remove>' +
                '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16 M9 7V5.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V7 M6.5 7l.8 12a1 1 0 0 0 1 .9h7.4a1 1 0 0 0 1-.9l.8-12"></path></svg>' +
              '</button>' +
            '</div>' +
            (variantTitle ? '<div class="svc__meta-sm">Pack Size: ' + esc(variantTitle) + '</div>' : '') +
            (planName ? '<div class="svc__meta-lg' + (planOverridden ? ' svc__meta-lg--ink' : '') + '">' + esc(planName).replace(/\n/g, '<br>') + '</div>' : '') +
            '<div class="svc__item-price">' + priceHtml + '</div>' +
            '<div class="svc__stepper">' +
              '<button type="button" data-svc-dec aria-label="Decrease quantity">–</button>' +
              '<div class="svc__stepper-val">' + item.quantity + '</div>' +
              '<button type="button" data-svc-inc aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        (showUpgrade
          ? '<button class="svc__btn svc__upgrade" type="button" data-svc-upgrade="' + esc(CFG.plans.upgrade.toOption) + '">' + esc(CFG.plans.upgrade.label) + '</button>'
          : (showPlan ? planSelectHtml(plan) : '')) +
      '</div>';
  }

  function render() {
    var cart = state.cart;
    if (!cart) return;

    var hasItems = cart.item_count > 0;
    el.items.innerHTML = hasItems ? cart.items.map(itemHtml).join('') : '';
    el.empty.hidden = hasItems;
    el.checkout.style.display = hasItems ? '' : 'none';
    el.total.textContent = money(cart.total_price);

    // Discounts = subscription savings (configured per option, in pence) + any discount codes
    var disc = cart.total_discount || 0;
    cart.items.forEach(function (i) {
      var o = planOptionFor(i);
      if (o && o.savingsPerUnit) disc += o.savingsPerUnit * i.quantity;
    });
    el.discount.hidden = disc <= 0;
    el.discountAmt.textContent = disc > 0 ? '−' + money(disc) : '';

    // Free shipping meter (only meaningful in the threshold currency)
    var showShip = hasItems && cart.currency === CFG.freeShippingCurrency && CFG.freeShippingThreshold > 0;
    el.ship.hidden = !showShip;
    if (showShip) {
      // Subscriptions ship free regardless of basket value (shipping rules already handle this at checkout)
      var hasSub = cart.items.some(function (i) { return !!i.selling_plan_allocation; });
      var left = hasSub ? 0 : Math.max(0, CFG.freeShippingThreshold - cart.total_price);
      el.shipNote.textContent = left > 0
        ? 'Add ' + money(left) + ' or subscribe for free shipping!'
        : 'You\u2019ve unlocked Free Shipping!';
      el.meter.style.width = (hasSub ? 100 : Math.min(100, (cart.total_price / CFG.freeShippingThreshold) * 100)).toFixed(2) + '%';
    }

    // Recs: hide anything already in the cart
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var sampleOnly = hasItems && CFG.plans && CFG.plans.sampleHandle &&
      cart.items.every(function (i) { return i.handle === CFG.plans.sampleHandle; });
    var visibleRecs = 0;
    $$('[data-svc-rec]').forEach(function (r) {
      var hide = !!inCart[Number(r.getAttribute('data-product-id'))];
      if (r.hasAttribute('data-svc-only-sample') && !sampleOnly) hide = true;
      r.hidden = hide;
      if (!hide) visibleRecs++;
    });
    el.recs.hidden = visibleRecs === 0;

    updateHeaderCount(cart.item_count);
  }

  function updateHeaderCount(n) {
    // Motion/Impulse header bubble
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (b) { b.textContent = n; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', n > 0);
    });
    // Generic hooks for any custom header
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; });
    document.dispatchEvent(new CustomEvent('semveta:cart:updated', { detail: state.cart }));
  }

  /* ---------- cart ops ---------- */

  function refresh() {
    return api(CFG.routes.cart).then(function (cart) {
      state.cart = cart;
      render();
      return cart;
    });
  }

  function change(key, quantity) {
    setBusy(true);
    return api(CFG.routes.change, { id: key, quantity: quantity })
      .then(function (cart) { state.cart = cart; render(); })
      .catch(handleError)
      .then(function () { setBusy(false); });
  }

  function add(items) {
    setBusy(true);
    return api(CFG.routes.add, { items: items })
      .then(refresh)
      .catch(handleError)
      .then(function () { setBusy(false); });
  }

  function switchPlan(item, option) {
    // Remove the current line, then add the target variant/plan with the same quantity.
    setBusy(true);
    var payload = { id: option.variantId, quantity: item.quantity };
    if (option.sellingPlanId) payload.selling_plan = option.sellingPlanId;
    return api(CFG.routes.change, { id: item.key, quantity: 0 })
      .then(function () { return api(CFG.routes.add, { items: [payload] }); })
      .then(refresh)
      .catch(function (e) { handleError(e); return refresh(); })
      .then(function () { setBusy(false); });
  }

  function handleError(e) {
    console.error('[SemvetaCart]', e);
    window.alert(e && e.message ? e.message : 'Something went wrong updating your cart.');
  }

  function findItem(key) {
    if (!state.cart) return null;
    for (var i = 0; i < state.cart.items.length; i++) if (state.cart.items[i].key === key) return state.cart.items[i];
    return null;
  }

  /* ---------- open / close ---------- */

  function open() {
    if (state.open) return;
    state.open = true;
    state.lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('svc-locked');
    refresh();
    setTimeout(function () { el.drawer.focus(); }, 50);
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('svc-locked');
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  /* ---------- events inside the drawer ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-svc-close]')) { e.preventDefault(); close(); return; }
    if (state.busy) return;

    var addBtn = t.closest('[data-svc-add]');
    if (addBtn) {
      addBtn.disabled = true;
      var addPayload = { id: Number(addBtn.getAttribute('data-svc-add')), quantity: 1 };
      var addPlan = addBtn.getAttribute('data-svc-plan');
      if (addPlan) addPayload.selling_plan = Number(addPlan);
      add([addPayload]).then(function () { addBtn.disabled = false; });
      return;
    }

    var line = t.closest('[data-svc-item]');
    if (!line) return;
    var item = findItem(line.getAttribute('data-key'));
    if (!item) return;

    var up = t.closest('[data-svc-upgrade]');
    if (up) {
      var target = CFG.plans.options.filter(function (o) { return o.id === up.getAttribute('data-svc-upgrade'); })[0];
      if (target) switchPlan(item, target);
      return;
    }
    if (t.closest('[data-svc-remove]')) { change(item.key, 0); return; }
    if (t.closest('[data-svc-inc]')) { change(item.key, item.quantity + 1); return; }
    if (t.closest('[data-svc-dec]')) { change(item.key, Math.max(0, item.quantity - 1)); return; }
  });

  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-svc-plan]');
    if (!sel || state.busy) return;
    var line = sel.closest('[data-svc-item]');
    var item = findItem(line.getAttribute('data-key'));
    var option = CFG.plans.options.filter(function (o) { return o.id === sel.value; })[0];
    if (!item || !option) return;
    var current = planOptionFor(item);
    if (current && current.id === option.id) return;
    switchPlan(item, option);
  });

  el.checkout.addEventListener('click', function (e) {
    e.preventDefault();
    window.location.href = CFG.routes.checkout;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  /* ---------- global triggers ---------- */

  // Header cart icon / any cart link
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href="/cart/"], [data-open-cart], .js-drawer-open-cart');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    open();
  });

  // Add-to-cart forms (theme, PageFly, custom) — capture phase so we win over theme JS
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (state.busy) return;

    var fd = new FormData(form);
    var id = Number(fd.get('id'));
    if (!id) { form.submit(); return; }

    var payload = { id: id, quantity: Number(fd.get('quantity')) || 1 };
    var plan = fd.get('selling_plan');
    if (plan) payload.selling_plan = Number(plan);

    var props = {};
    var hasProps = false;
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) { props[m[1]] = v; hasProps = true; }
    });
    if (hasProps) payload.properties = props;

    open();
    add([payload]);
  }, true);

  // Catch adds made by apps (PageFly, Skio, etc.) that call /cart/add themselves.
  // Any successful POST to /cart/add from any script opens and refreshes the drawer.
  function isCartAdd(url, method) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url) && String(method || 'GET').toUpperCase() === 'POST';
  }
  function onExternalAdd() {
    if (state.busy) return;
    open();
    refresh();
  }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method);
      var p = _fetch.apply(this, arguments);
      if (isCartAdd(url, method)) {
        p.then(function (r) { if (r && r.ok) onExternalAdd(); }).catch(function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartAdd(url, method)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) onExternalAdd();
        });
      }
      return _open.apply(this, arguments);
    };
  }

  // Public API
  window.SemvetaCart = { open: open, close: close, refresh: refresh, add: add };

  // Initial header count
  refresh();
})();